import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

/**
 * Kapselt den Wide-Layout-Zustand der Task-Details Seite
 * inkl. Persistierung in der sessionStorage.
 */
@Injectable()
export class TaskLayoutService {
  private readonly translateService = inject(TranslateService);
  private readonly storageKey = 'task-details-wide-layout';

  private _isWideLayout = false;
  private _buttonMaxWidthTitle = this.translateService.instant(
    'costcenter.costcenter_usage.max_width'
  );

  get isWideLayout(): boolean {
    return this._isWideLayout;
  }

  get buttonMaxWidthTitle(): string {
    return this._buttonMaxWidthTitle;
  }

  /** Initialisiert den Service mit dem in der Session gespeicherten Wert (falls vorhanden). */
  restorePreference(): void {
    try {
      const storedValue = sessionStorage.getItem(this.storageKey);
      if (storedValue !== null) {
        this.set(JSON.parse(storedValue) === true);
        return;
      }
    } catch {
      /* ignore */
    }
    this.set(false);
  }

  toggle(): void {
    this.set(!this._isWideLayout);
  }

  private set(isWideLayout: boolean): void {
    this._isWideLayout = isWideLayout;
        this._buttonMaxWidthTitle = this.translateService.instant(
      isWideLayout
        ? 'taskmodule.task.button.tooltip.reset'
        : 'taskmodule.task.button.tooltip.max_width'
    );

    try {
      sessionStorage.setItem(this.storageKey, JSON.stringify(isWideLayout));
    } catch {
      /* ignore */
    }
  }
}
